import { render, staticRenderFns } from "./EditPickup.vue?vue&type=template&id=5cc377f8&"
import script from "./EditPickup.vue?vue&type=script&lang=js&"
export * from "./EditPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports